import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
export const registerAdditionalHeadersInterceptor = (settings, instance) => {
    const interceptorId = instance.interceptors.request.use(config => {
        config.headers['x-converse-client'] = `${settings.hostName}/${settings.hostRevision}`;
        config.headers['x-converse-platform'] = 'web';
        config.headers['x-converse-language'] = window.navigator.language;
        config.headers['x-converse-request-id'] = uuidv4();
        return config;
    });
    return () => {
        instance.interceptors.request.eject(interceptorId);
    };
};
export const isUnauthorizedError = (queryError) => axios.isAxiosError(queryError) && queryError.response?.status === 401;
//# sourceMappingURL=axios.js.map